const LAST_CLIENT_CRASH_KEY = 'servernox:last-client-crash'

export type ClientCrashRecord = {
  at: string
  message: string
  path: string
  source: string
  component_stack?: string
}

export function clientCrashMessage(value: unknown): string {
  const raw = value instanceof Error
    ? value.message
    : typeof value === 'string'
      ? value
      : value && typeof value === 'object' && 'message' in value
        ? String((value as { message?: unknown }).message || '')
        : String(value || 'Bilinmeyen istemci hatası')
  return raw.replace(/[\r\n\t]+/g, ' ').replace(/\s{2,}/g, ' ').trim().slice(0, 500) || 'Bilinmeyen istemci hatası'
}

export function recordClientCrash(value: unknown, source: string, componentStack = ''): ClientCrashRecord {
  const record: ClientCrashRecord = {
    at: new Date().toISOString(),
    message: clientCrashMessage(value),
    path: typeof window === 'undefined' ? '' : `${window.location.pathname}${window.location.search}`.slice(0, 500),
    source: String(source || 'runtime').slice(0, 80),
  }
  const stack = String(componentStack || '').trim().slice(0, 2000)
  if (stack) record.component_stack = stack
  try { localStorage.setItem(LAST_CLIENT_CRASH_KEY, JSON.stringify(record)) } catch {}
  return record
}

export function lastClientCrash(): ClientCrashRecord | null {
  try {
    const value = JSON.parse(localStorage.getItem(LAST_CLIENT_CRASH_KEY) || 'null')
    if (!value || typeof value !== 'object' || typeof value.message !== 'string') return null
    return value as ClientCrashRecord
  } catch {
    return null
  }
}

export async function clearClientRuntimeCaches(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.allSettled(registrations.map(registration => registration.unregister()))
    }
  } catch {}
  try {
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.allSettled(keys.map(key => caches.delete(key)))
    }
  } catch {}
}
